// Cross-component nudge for the nav badge counts. Pages that change unread
// state (e.g. opening a message thread marks it read) fire this so Layout
// refetches immediately instead of waiting out its slow poll.
export const BADGES_STALE_EVENT = 'iron:badges-stale';

export function notifyBadgesStale(): void {
  window.dispatchEvent(new Event(BADGES_STALE_EVENT));
}
